import type { FeedPageType } from "@/features/feed/contract"
import type { FeedViewContext } from "@/features/feed/preview-context"

export const feedKeys = {
  all: ["feed"] as const,
  pages: (pageType: FeedPageType, handle: string, initialCursor: string, viewer: string, context: FeedViewContext = {}) =>
    [...feedKeys.all, pageType, handle, initialCursor, viewer, context] as const,
}
